/*
 * @Description:审批代理
 * @Autor: lwq
 * @Date: 2020-07-29 09:48:51
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-29 17:06:53
 * @FilePath: \mrc-base-server-view\src\service\api\approver.js
 */

import http from '../httpConfig'

const table = "mrbase_sys_flow_proxy_approval"

// 列表
export const approverList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/list-approval/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 新增
export const addApprover = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/add-approval/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 删除
export const delApprover = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/delete-approval/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 修改
export const updateApprover = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/update-approval/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 详情
export const detailApprover = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/find-approval/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}